/* eslint-disable */
import { CognitoAuth, StorageHelper } from "amazon-cognito-auth-js";
import IndexRouter from "../router/index";
import UserInfoStore from "./user-info-store";
import Store from "../store/index";
import UserInfoApi from "./user-info-api";

const CLIENT_ID = process.env.VUE_APP_COGNITO_CLIENT_ID;
const APP_DOMAIN = process.env.VUE_APP_COGNITO_APP_DOMAIN;
const REDIRECT_URI = process.env.VUE_APP_COGNITO_REDIRECT_URI;
const USERPOOL_ID = process.env.VUE_APP_COGNITO_USERPOOL_ID;
const REDIRECT_URI_SIGNOUT = process.env.VUE_APP_COGNITO_REDIRECT_URI_SIGNOUT;

var authData = {
    ClientId: CLIENT_ID, // Your client id here
    AppWebDomain: APP_DOMAIN,
    TokenScopesArray: ["openid", "email"],
    RedirectUriSignIn: REDIRECT_URI,
    RedirectUriSignOut: REDIRECT_URI_SIGNOUT,
    UserPoolId: USERPOOL_ID,
};

// console.log(authData, 'authData')
var auth = new CognitoAuth(authData);
// console.log(auth, 'auth')
auth.userhandler = {
    onSuccess: function (result) {
        UserInfoStore.setLoggedIn(true);
        Store.commit("resetDashbboardInfoData");
        UserInfoApi.getUserInfo().then((response) => {
            IndexRouter.push("/");
        });
    },
    onFailure: function (err) {
        UserInfoStore.setLoggedOut();
        Store.state.cognitoInfo = {};
        Store.commit("resetCognitoInfo");
        IndexRouter.go({
            path: "/error",
            query: { message: "Login failed due to " + err },
        });
    },
};

function getUserInfoStorageKey() {
    var keyPrefix = "CognitoIdentityServiceProvider." + auth.getClientId();
    var tokenUserName = auth.signInUserSession.getAccessToken().getUsername();
    var userInfoKey = keyPrefix + "." + tokenUserName + ".userInfo";
    return userInfoKey;
}

var storageHelper = new StorageHelper();
var storage = storageHelper.getStorage();
export default {
  auth: auth,
  login() {
    auth.getSession();
  },
  logout() {
    if (auth.isUserSignedIn()) {
      var userInfoKey = this.getUserInfoStorageKey();
      storage.removeItem(userInfoKey);

      Store.state.loader = 0;
      Store.commit("resetCognitoInfo");
      Store.commit("resetDealFilter");
      Store.commit("resetDashboardInfo");
      Store.commit("resetDashbboardFilter");

      auth.signOut();
    }
  },
  getUserInfoStorageKey,
};